import { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

type Props = {
  onVoid?: () => void;
  onRefund?: () => void;
};

export const SubscriptionInvoicesActionMenu = ({ onVoid, onRefund }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleVoid = () => {
    handleClose();
    if (!onVoid) return;
    onVoid();
  };

  const handleRefund = () => {
    handleClose();
    if (!onRefund) return;
    onRefund();
  };

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Tooltip
          title={!onVoid ? "Void not available" : ""}
          arrow
          placement="left"
        >
          <div>
            <MenuItem onClick={handleVoid} disabled={!onVoid}>
              Void Invoice
            </MenuItem>
          </div>
        </Tooltip>
        <Tooltip
          title={!onRefund ? "Refund not available" : ""}
          arrow
          placement="left"
        >
          <div>
            <MenuItem onClick={handleRefund} disabled={!onRefund}>
              Refund Invoice
            </MenuItem>
          </div>
        </Tooltip>
      </Menu>
    </>
  );
};
